import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) => state.statusSlice.statusPlan;

export const selectReservationType = (gridElementId: string) => {
  const selector = (state: RootState): string => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return "";
    return data?.reservationType.toUpperCase();
  };
  (selector as any)._fromSelector = "reservationTypeSelector";
  return selector;
};
